import { CrudList } from '../shared/CrudPage';
import { restaurantTableService } from '@kss/api';
import type { RestaurantTable, RestaurantTableCreate, RestaurantTableFilter } from '@kss/api';

export default function AllRestaurantTables() {
  return (
    <CrudList<RestaurantTable, RestaurantTableCreate, RestaurantTableFilter>
      title="Restaurant Tables"
      newLabel="New restaurant table"
      service={restaurantTableService}
      idKey="restaurantTableId"
      labelKey="name"
      basePath="/panel/restaurant-tables"
      columns={[
        { accessor: 'code', title: 'Table #', sortable: true, width: 100 },
        { accessor: 'name', title: 'Name', filterable: true },
        { accessor: 'floor' as never, title: 'Floor', width: 90 },
        { accessor: 'section' as never, title: 'Section', width: 130 },
        { accessor: 'capacity' as never, title: 'Capacity', width: 90 },
        { accessor: 'tableStatus' as never, title: 'Status', width: 120 },
      ]}
    />
  );
}
